/**
 * 客服联系邮箱（单一事实来源）。
 *
 * Creem MoR 合规要求：可达的客服邮箱必须展示在公开网站与用户 dashboard，
 * 且与 Creem Store settings 里的商家资料一致（support@tsuvi.com 为品牌域名邮箱）。
 * 展示位置：落地页 FAQ 区、定价页 footer、FAQ 页、「我的订阅」页、法律页正文。
 */

export const SUPPORT_EMAIL = "support@tsuvi.com";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
